var vanillaforum=(window.webpackJsonpvanillaforum=window.webpackJsonpvanillaforum||[]).push([[6],{499:function(t,e,n){n(64),t.exports=n(500)},500:function(t,e,n){"use strict";n.r(e);var c=n(4),a=n(17),o=n(54),b=n(26);
/**
 * Primary bootstrapping of the frontend JS. This entrypoint should be the last once executed.
 *
 * @copyright 2009-2019 Vanilla Forums Inc.
 * @license GPL-2.0-only
 */
Object(a.b)(Object(c.g)("debug",!1)),o.a.apiv2=b.a,Object(a.f)("Bootstrapping"),Object(c.a)().then(function(){Object(a.f)("Bootstrapping complete."),Object(c.k)(function(t){Object(c.b)(t.target)});var t=new CustomEvent("X-DOMContentReady",{bubbles:!0,cancelable:!1});document.dispatchEvent(t)}).catch(function(t){Object(a.g)(t)})},64:function(t,e,n){"use strict";n.r(e);var c=n(4);
/**
 * Set wepback's public path.
 * Otherwise the lookups of dynamically imported webpack files can fail on sites that have a different webroot
 * Eg. installed in a subfolder / using Reverse Proxy.
 *
 * @author Adam Charron <adam.c@vanillaforums.com>
 * @copyright 2009-2018 Vanilla Forums Inc.
 * @license GPL-2.0-only
 */n.p=Object(c.e)("/dist/forum/")}},[[499,2,1,0]]]);